import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import axiosInstance from '../api/axios';
import useAuthStore from '../store/useAuthStore';
import { motion } from 'framer-motion';
import { Mail, Lock, LogIn, Loader2 } from 'lucide-react';

const Login = () => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { login } = useAuthStore();

    const onSubmit = async (data) => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.post('/login', data);
            const { user, token } = response.data;
            login(user, token);
            toast.success(`Welcome back, ${user.name}! 🎉`);
            if (user.role === 'admin') {
                navigate('/dashboard');
            } else {
                navigate('/clients');
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Invalid credentials.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '60px 20px' }}>
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="glass-card" style={{ width: '100%', maxWidth: '420px', padding: '40px', backgroundColor: 'white', borderRadius: '16px', boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)' }}>
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#0f172a' }}>Welcome Back</h2>
                    <p style={{ margin: '8px 0 0 0', color: '#64748b', fontSize: '15px' }}>Enter your credentials to access your account</p>
                </div>

                <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#334155' }}>Email Address</label>
                        <div style={{ position: 'relative' }}>
                            <div style={{ position: 'absolute', top: '50%', left: '12px', transform: 'translateY(-50%)', color: '#94a3b8' }}><Mail size={18} /></div>
                            <input type="email" placeholder="name@company.com" {...register('email', { required: 'Email required' })} style={{ width: '100%', padding: '12px 12px 12px 40px', border: '1px solid #e2e8f0', borderRadius: '8px', outline: 'none' }} />
                        </div>
                    </div>

                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#334155' }}>Password</label>
                        <div style={{ position: 'relative' }}>
                            <div style={{ position: 'absolute', top: '50%', left: '12px', transform: 'translateY(-50%)', color: '#94a3b8' }}><Lock size={18} /></div>
                            <input type="password" placeholder="••••••••" {...register('password', { required: 'Password required' })} style={{ width: '100%', padding: '12px 12px 12px 40px', border: '1px solid #e2e8f0', borderRadius: '8px', outline: 'none' }} />
                        </div>
                    </div>

                    <button type="submit" disabled={isLoading} className="action-btn" style={{ width: '100%', padding: '12px', backgroundColor: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
                        {isLoading ? <><Loader2 size={18} className="animate-spin" /> Signing in...</> : <>Sign In <LogIn size={18} /></>}
                    </button>
                </form>
            </motion.div>
        </div>
    );
};

export default Login;